import createLucideIcon from '../createLucideIcon';

const Play = createLucideIcon('PlayIcon', [
  ['polygon', { points: '5 3 19 12 5 21 5 3', key: '191637' }],
]);

export default Play;
